import styled from "styled-components"

export const PreviewWrapper = styled.div`
  height: calc(100% - var(--header-height));
  background: #ffffff;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const HeaderSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 24px;
  margin-top: 0;
`

export const HeadingContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const HeadingTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`

export const HeadingDescription = styled.p`
  font-size: 14px;
  color: #576066;
`

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ImageCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: #ffffff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  width: 100%;
  height: 375px;
`

export const ImagePreviewWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 327px;
  border-radius: 24px;
  overflow: hidden;
`

export const ImagePreview = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`

export const BottomActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 12px 24px 24px;
  background: #ffffff;
  margin-top: auto;
`

export const RetakeTextContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
  font-size: 14px;
`

export const RetakePromptText = styled.span`
  font-weight: 400;
  line-height: 1.6;
  white-space: nowrap;
`

export const RetakeButton = styled.button`
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  color: #0da3ba;
  text-align: center;
  white-space: nowrap;

  &:active {
    opacity: 0.7;
  }
`

export const PhotoUploadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--Schemes-Surface-Container-Low, #f5f7f7);
  border-radius: 19.856px;
  background: var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));
  height: 327px;
  width: 100%;
  position: relative;
`
